/**
 * App global config
 * Pakistan default: Asia/Karachi (UTC+5)
 */

export const APP_TIMEZONE = 'Asia/Karachi';
